/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Equipe • Mais de 50 membros',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Equipe • Mais de 50 membros, incluindo você',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Equipe • 1 membro} other {Equipe • {0} membros}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Equipe • 1 membro, incluindo você} other {Equipe • {0} membros, incluindo você}}',
  'fabric.mention.error.defaultAction': 'Tente novamente em alguns segundos',
  'fabric.mention.error.defaultHeadline': 'Algo deu errado',
  'fabric.mention.error.differentText': 'Tente inserir outro texto',
  'fabric.mention.error.loginAgain': 'Tente sair e fazer login novamente',
  'fabric.mention.noAccess.label': 'Sem acesso',
  'fabric.mention.noAccess.warning': '{name} não será notificado(a) porque não tem acesso',
  'fabric.mention.unknow.user.error': 'Usuário desconhecido {userId}'
};